/* eslint-disable no-case-declarations */
import { useEffect, useState } from 'react';
import { fetchActivity } from '../../../modules/api';
import { initialListingFilterObj } from '../../utils/constants';
import useFilters from '../../globalHooks/useFilters';

const useActivityListing = (id) => {
  const [activities, setActivities] = useState([]);
  const [rawActivities, setRawActivities] = useState([]);
  const [waiting, setWaiting] = useState(true);
  const [error, setError] = useState(null);
  const [destinations, setDestinations] = useState([]);
  const [activeFilters, setActiveFilters] = useState({
    ...initialListingFilterObj,
  });
  const [sort, setSort] = useState('popular');
  const [currentPage, setCurrentPage] = useState(0);

  const { filterDestination } = useFilters(activeFilters);

  useEffect(() => {
    if (id && rawActivities.length < 1) {
      (async () => {
        const feed = await getActivityFeed(id);
        setActivities(feed);
        setRawActivities(feed);
        setDestinations(getDestinations(feed));
      })();
    }
  }, [id]);

  const getDestinations = (feed) => {
    let returner = [
      {
        display: 'All',
        slug: 'All',
        id: 0,
      },
    ];

    feed.forEach(({ destinations }, index) => {
      if (destinations) {
        destinations.forEach((destination) => {
          if (!returner.find(({ slug }) => slug === destination.slug)) {
            returner = [...returner, destination];
          }
        });
      }
    });

    return returner;
  };

  useEffect(() => {
    let newActivities = filterDestination(rawActivities);

    newActivities = sortActivities(sort, [...newActivities]);
    setActivities(newActivities);
    setCurrentPage(0);
  }, [JSON.stringify(activeFilters), JSON.stringify(rawActivities), sort]);

  const getActivityFeed = async (id = '') => {
    try {
      setWaiting(true);

      return await fetchActivity(id);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Can not get activities feed', error);
      setError('An unexpected error has occurred');
    } finally {
      setWaiting(false);
    }
  };

  const sortActivities = (sort, activities) => {
    switch (sort) {
      case 'popular':
        return activities.sort(
          (a, b) => parseInt(a.popularity, 10) - parseInt(b.popularity, 10)
        );
      case 'new':
        return activities;
      case 'price_low':
        // use low price
        return activities;
      case 'price_high':
        // use high price
        return activities;
      case 'a-z':
        // alphabet ascending
        return activities.sort((a, b) =>
          a.title.display.charAt(0).toLowerCase() >
          b.title.display.charAt(0).toLowerCase()
            ? 1
            : -1
        );
      case 'z-a':
        // alphabet descending
        return activities.sort((a, b) =>
          b.title.display.charAt(0).toLowerCase() >
          a.title.display.charAt(0).toLowerCase()
            ? 1
            : -1
        );
      default:
        return activities;
    }
  };

  return {
    waiting,
    activities,
    rawActivities,
    error,
    setError,
    destinations,
    activeFilters,
    setActiveFilters,
    setSort,
    currentPage,
    setCurrentPage,
  };
};

export default useActivityListing;
